import User from "./User" ;
import DateTime from "../core/DateTime" ;
import DBObject from "../utils/DBObject" ;
import CloneContext from "../utils/CloneContext" ;


  export default  class  AuditRecord extends  DBObject {  private static readonly _ACTION: number = 0 ;
  private static readonly _ACTIONDESCRIPTION: number = 1 ;
  private static readonly _ACTIONOWNER: number = 2 ;
  private static readonly _CREATEDDATE: number = 3 ;
  public id: number = 0 ;
  public otherMaster: DBObject ;
  private _actionOwner: User = null ;
  private _action: string = '' ;
  private _actionDescription: string = '' ;
  private _createdDate: DateTime = null ;
 public constructor ( d3eParams ? : Partial<{action: string, actionDescription: string, actionOwner: User, createdDate: DateTime}> ) {
 super();

this.setAction(d3eParams?.action ?? '');

this.setActionDescription(d3eParams?.actionDescription ?? '');

this.setActionOwner(d3eParams?.actionOwner ?? null);

this.setCreatedDate(d3eParams?.createdDate ?? null);
 }
  public get d3eType (  ) : string {
 return 'AuditRecord' ; 
 }
  public clear (  ) : void {
 this.d3eChanges.clear();
 }
  public get actionOwner (  ) : User {
 return this._actionOwner ; 
 }
  public setActionOwner ( val : User ) : void {
 let isValChanged :boolean=this._actionOwner !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateD3EChanges(AuditRecord._ACTIONOWNER,this._actionOwner);

this.updateObservable('actionOwner',this._actionOwner,val);

this._actionOwner=val;

this.fire('actionOwner',this);
 }
  public get action (  ) : string {
 return this._action ; 
 }
  public setAction ( val : string ) : void {
 let isValChanged :boolean=this._action !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateD3EChanges(AuditRecord._ACTION,this._action);

this._action=val;

this.fire('action',this);
 }
  public get actionDescription (  ) : string {
 return this._actionDescription ; 
 }
  public setActionDescription ( val : string ) : void {
 let isValChanged :boolean=this._actionDescription !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateD3EChanges(AuditRecord._ACTIONDESCRIPTION,this._actionDescription);

this._actionDescription=val;

this.fire('actionDescription',this);
 }
  public get createdDate (  ) : DateTime {
 return this._createdDate ; 
 }
  public setCreatedDate ( val : DateTime ) : void {
 let isValChanged :boolean=this._createdDate !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateD3EChanges(AuditRecord._CREATEDDATE,this._createdDate);

this._createdDate=val;

this.fire('createdDate',this);
 }
  public get ( field : number ) : any {
 switch ( field ) {
 case AuditRecord._ACTIONOWNER : {
 return this._actionOwner ; 
 }

case AuditRecord._ACTION : {
 return this._action ; 
 }

case AuditRecord._ACTIONDESCRIPTION : {
 return this._actionDescription ; 
 }

case AuditRecord._CREATEDDATE : {
 return this._createdDate ; 
 }
 default: {
 return null ; 
 }
 }
 }
  public updateD3EChanges ( index : number,value : any ) : void {
 if ( this.lockedChanges() ) {
 return ; 
 }

super.updateD3EChanges(index,value);
 }
  public restore (  ) : void {
 /*
TODO: Might be removed
*/

this.d3eChanges.restore(this);
 }
  public deepClone ( clearId = true ) : AuditRecord {
 let ctx :CloneContext=new CloneContext({ 'clearId':clearId });

return ctx.startClone(this) ; 
 }
  public collectChildValues ( ctx : CloneContext ) : void {
  }
  public deepCloneIntoObj ( dbObj : DBObject,ctx : CloneContext ) : void {
 let obj :AuditRecord=( dbObj as AuditRecord );

obj.id=this.id;

obj.setActionOwner(this._actionOwner);

obj.setAction(this._action);

obj.setActionDescription(this._actionDescription);

obj.setCreatedDate(this._createdDate);
 }
  public set ( field : number,value : any ) : void {
 switch ( field ) {
 case AuditRecord._ACTIONOWNER : {
 this.setActionOwner(( value as User ));
 break; }

case AuditRecord._ACTION : {
 this.setAction(( value as string ));
 break; }

case AuditRecord._ACTIONDESCRIPTION : {
 this.setActionDescription(( value as string ));
 break; }

case AuditRecord._CREATEDDATE : {
 this.setCreatedDate(( value as DateTime ));
 break; }
 }
 }
 }